module.exports = __webpack_public_path__ + "img/main1.27802fd3.png";